import { format } from 'date-fns'
import { FireRiskEnum } from '../enum/FireRisk.enum'

export class RecentFireRisk {
	constructor(
		readonly fmaPlus: number,
		readonly timestamp: Date,
		readonly id: string,
		readonly risk: FireRiskEnum,
		readonly monitoredAreaName: string,
	) {}

	get dateLabel(): string {
		return format(new Date(this.timestamp), "dd/MM/yyyy 'às' HH:mm:ss")
	}

	get riskLabel(): string {
		switch (this.risk) {
			case FireRiskEnum.NONE:
				return 'NULO'
			case FireRiskEnum.NULL:
				return 'NENHUM'
			case FireRiskEnum.SMALL:
				return 'PEQUENO'
			case FireRiskEnum.MEDIUM:
				return 'MÉDIO'
			case FireRiskEnum.HIGH:
				return 'ALTO'
			case FireRiskEnum.HIGHEST:
				return 'MUITO ALTO'
		}
	}
}
